import script from "./HrOptionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./HrOptionGroup.vue?vue&type=script&setup=true&lang=js"

import "./HrOptionGroup.vue?vue&type=style&index=0&id=18cdbdf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18cdbdf9"]])

export default __exports__